import { IAnalyticsAdapter } from '@/HostApp/types/AnalyticsModule';

const timeEvents: string[] = ['panelReady', 'navigationResponded', 'contextSent', 'viewShown'];

let instance: GoogleAnalyticsAdapter | null = null;
export default class GoogleAnalyticsAdapter implements IAnalyticsAdapter {
	private hasGTM: boolean = true;

	static getInstance(): GoogleAnalyticsAdapter {
		return instance || new GoogleAnalyticsAdapter();
	}

	constructor() {
		if (!window.dataLayer) {
			// eslint-disable-next-line no-console
			console.info(`GTM is not configured!`);
			this.hasGTM = false;
		}

		instance = this;
	}

	public pushData(data: Analytics.IGAEvent): void {
		if (!this.hasGTM) return;

		if ('eventValue' in data && timeEvents.includes(data.event) && data.eventValue && data.eventValue > 600000)
			return;

		data.eventCategory = data.eventCategory || data.event;
		data.eventAction = data.eventAction || data.event;
		data.dimension13 = 'UX1Panel';

		performance.mark(data.event);

		window.dataLayer.push(data);
	}

	public pushException(viewId: string, viewLabel: string, message: string): void {
		if (!this.hasGTM) return;

		window.dataLayer.push({
			eventCategory: 'exception',
			event: 'exception',
			eventAction: viewLabel,
			eventLabel: viewId,
			dimension10: message,
			dimension13: 'UX1Panel'
		});
	}
}
